import { logError, logWarning } from '@/utils/miscUtils';
import { APIFormDataCC } from '@/components/Quiz/Quiz.helpers';

interface HttpError extends Error {
	response?: {
		status: number;
		data: unknown; 
	};
}

export default async function postQuizCC(
	url: string,
	formData: APIFormDataCC,
	headers: { [key: string]: string } = {}
) {
	try {
		const response = await fetch(url, {
			method: "POST",
			body: JSON.stringify({
				answers: formData.answers,
				subject: formData.subject
			}),
			headers,
		});

		const data = await response.json() as unknown;

		if (response.status === 403) {
			logWarning(`Could not post quiz to userEvents api`);
			logError("403: Lead failed fidelity check, returning `data` for local handling.");
			return data;
		}

		if (response.ok) {
			return data;
		}

		return Promise.reject(new Error(`Unexpected response status: ${response.status}`));
	} catch (err: unknown) {
		logWarning(`Could not post quiz to userEvents api`);
		const error = err as HttpError;

		if (error.response) {
			const { status, data } = error.response;

			if (status === 403) {
				logError("403: Lead failed fidelity check, returning `data` for local handling.");
				return data;
			}
		}

		return error;
	}
}